var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.imagedata.imagetype == "default" ||
    _vm.imagedata.imagetype == "screen"
    ? _c(
        "div",
        {
          staticClass: "col-xs-12 col-sm-12 p-0",
          class: [
            _vm.imagedata.align == "right" && !_vm.paddingImage
              ? "col-md-push-6"
              : "",
            _vm.imagedata.bg_color !== undefined &&
            _vm.imagedata.bg_color == "default"
              ? "bg-color-blue"
              : "",
            _vm.paddingImage ? "col-md-4 col-lg-4" : "col-md-6",
          ],
        },
        [
          _c("img", {
            staticClass: "img-style",
            class: {
              "p-50": _vm.paddingImage,
              "default-style": _vm.imagedata.imagetype == "default",
              "img-style": _vm.imagedata.imagetype == "screen",
              "gg-style": _vm.imagedata.gg_img,
            },
            attrs: {
              src: `${_vm.getImageUrl(_vm.imagedata.image)}`,
              alt: "img",
            },
          }),
        ]
      )
    : _c(
        "div",
        {
          staticClass: "col-xs-12 col-sm-12 col-md-6 p-0",
          class: { "laptop-wrapper": _vm.imagedata.imagetype == "laptop" },
          style: [
            _vm.imagedata.imagetype == "laptop"
              ? { height: _vm.laptopBlockHeight + "px" }
              : "",
          ],
        },
        [
          _vm.imagedata.imagetype == "desktop"
            ? _c("div", { staticClass: "img-center desktop-wrapper" }, [
                _c("div", { staticClass: "col-xs-12 mt-10 col-sm-12" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-11 desktop-border" },
                    [
                      _vm._m(0),
                      _c("div", { staticClass: "col-xs-12 p-0 rs-image" }, [
                        _c("img", {
                          staticClass: "desktop-image",
                          attrs: {
                            src: _vm.getImageUrl(_vm.imagedata.image),
                            width: "100%",
                            alt: "rs-img",
                          },
                        }),
                      ]),
                    ]
                  ),
                  _c("div", {
                    staticClass: "col-xs-12 col-sm-11 desktop-bottom",
                  }),
                  _vm._m(1),
                ]),
              ])
            : _vm._e(),
          _vm.imagedata.imagetype == "laptop"
            ? _c("div", { staticClass: "img-center laptop-block" }, [
                _c("div", { staticClass: "row mt-10" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-xs-12 col-sm-12 col-md-10 col-md-offset-1",
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass: "col-xs-10 col-xs-offset-1 laptop-box",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col-xs-12 p-0 rs-image" },
                              [
                                _c("img", {
                                  staticClass: "laptop-image",
                                  attrs: {
                                    src: _vm.getImageUrl(_vm.imagedata.image),
                                    width: "100%",
                                    alt: "rs-img",
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _vm._m(2),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-12 plr-5 mtb-2" }, [
      _c("div", {
        staticClass: "col-xs-offset-7 col-xs-5 desktop-top-gradient",
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-12 col-sm-11 text-align-center" }, [
      _c("img", {
        attrs: {
          src: "/static/images/marketplace/computer_stand.png",
          alt: "computer-img",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row m-0" }, [
      _c(
        "div",
        {
          staticClass: "col-xs-12 col-sm-12 laptop-bottom",
          attrs: { "data-v-7abf919a": "" },
        },
        [
          _c("div", {
            staticClass: "col-xs-6 p-0 laptop-bottom-gradient",
            attrs: { "data-v-7abf919a": "" },
          }),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }